export default __webpack_public_path__ + "1acb48d14c56f1e6f79fb3dfaf01bb8d.svg";